import { Component, inject, OnInit } from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';

import { BmWidgetFiltersComponent } from '../bm-widget-filters/bm-widget-filters.component';
import { ContractStatsComponent } from '../widgets/contract-stats/contract-stats.component';
import { ContractSummaryComponent } from '../widgets/contract-summary/contract-summary.component';
import { TopPerformersComponent } from '../widgets/top-performers/top-performers.component';
import { PolicyAlertsComponent } from '../widgets/policy-alerts/policy-alerts.component';
import { CommonModule } from '@angular/common';
import { PolicyDrilldownComponent } from '../policy-drilldown/policy-drilldown.component';

@Component({
  selector: 'app-rep-reports',
  templateUrl: './rep-reports.component.html',
  styleUrls: ['./rep-reports.component.scss'],
  imports: [
    BmWidgetFiltersComponent,
    ContractStatsComponent,
    ContractSummaryComponent,
    TopPerformersComponent,
    PolicyAlertsComponent,
    CommonModule,
    PolicyDrilldownComponent,
  ],
})
export class RepReportsComponent implements OnInit {
  private ss = inject(SessionStorageService);
  rights: string[] = [];
  showPolicyReview = false;
  showPolicyTags = false;
  preexistingWidgetFilters: any;

  constructor() {}

  ngOnInit() {
    this.rights = this.ss.get('rights');
    this.showPolicyReview = this.rights.includes(
      'PMRepTopPolicyReviewOpportunitiesGrid'
    );
    this.showPolicyTags = this.rights.includes('PMRepPolicyAlertsGrid');
  }

  emitDrilldownFilter(ev) {
    this.preexistingWidgetFilters = { ...ev };
  }
}
